import React from 'react';
import AboutPage from '../components/about';

export default function About() {
    return (
        <div>
            <AboutPage />
        </div>
    )
}